/** @jsxImportSource @emotion/react */
import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerTypeHint,
} from '@capacitor/barcode-scanner';
import { Icon } from '@quickbit/qb-design-system';
import { usePlatform } from 'hooks';

interface Props {
  onScan: (result: string) => void;
  scannerType?: 'qr';
}

const BARCODE_TYPE_TO_HINT = {
  qr: CapacitorBarcodeScannerTypeHint.QR_CODE,
};

export const BarcodeScanner = ({ onScan, scannerType = 'qr' }: Props) => {
  const { isNative } = usePlatform();
  if (!isNative) {
    return null;
  }

  const handleScan = async () => {
    try {
      const result = await CapacitorBarcodeScanner.scanBarcode({
        hint: BARCODE_TYPE_TO_HINT[scannerType],
      });
      onScan(result.ScanResult);
    } catch (error) {
      console.error('Error scanning barcode:', error);
    }
  };

  return (
    <div onClick={handleScan}>
      <Icon name="scan" />
    </div>
  );
};
